(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jcked-results')) {
    customElements.define('jcked-results', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.init());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        this.events?.abort();
        this.observer?.disconnect();
      }
      init() {
        clearTimeout(this.timer);
        this.events?.abort();
        this.observer?.disconnect();
        this.events = new AbortController();
        this.touching = false;
        const options = { signal: this.events.signal };
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.track.querySelectorAll('[data-loop-copy]').forEach((copy) => copy.remove());
        this.slides = [...this.querySelectorAll('[data-story]')];
        if (!this.slides.length) return;
        this.slides.forEach((slide, i) => { slide.dataset.resultIndex = String(i); });
        if (this.slides.length > 1) {
          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();
          this.slides.forEach((slide) => {
            before.append(this.copy(slide));
            after.append(this.copy(slide));
          });
          this.track.prepend(before);
          this.track.append(after);
        }
        this.cards = [...this.track.querySelectorAll('.jr__story')];
        this.counter = this.querySelector('[data-count]');
        this.setAttribute('data-ready', '');
        this.querySelector('[data-controls]').hidden = this.slides.length < 2;
        this.setCurrent(this.slides.length > 1 ? this.slides.length : 0);
        this.center(this.position, false);

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-step]');
          if (button && this.contains(button)) this.go(this.index + Number(button.dataset.step));
        }, options);
        this.track.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
          this.go(index);
        }, options);
        this.track.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
        this.track.addEventListener('scrollend', () => this.settle(), options);
        this.track.addEventListener('touchstart', () => { this.touching = true; clearTimeout(this.timer); }, { ...options, passive: true });
        const release = () => {
          if (!this.touching) return;
          this.touching = false;
          this.schedule();
        };
        window.addEventListener('touchend', release, { ...options, passive: true });
        window.addEventListener('touchcancel', release, { ...options, passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.indexOf(event.target.closest('[data-story]'));
          if (index >= 0) this.go(index, false);
        }, options);

        this.width = this.track.clientWidth;
        this.observer = new ResizeObserver(() => {
          if (this.width === this.track.clientWidth) return;
          this.width = this.track.clientWidth;
          this.go(this.index, false);
        });
        this.observer.observe(this.track);
      }
      copy(slide) {
        const clone = slide.cloneNode(true);
        clone.removeAttribute('data-story');
        clone.setAttribute('data-loop-copy', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        [clone, ...clone.querySelectorAll('*')].forEach((node) => {
          node.removeAttribute('id');
          node.removeAttribute('data-shopify-editor-block');
        });
        return clone;
      }
      setCurrent(position) {
        this.position = position;
        this.index = Number(this.cards[position].dataset.resultIndex);
        this.cards.forEach((card, i) => card.classList.toggle('is-current', i === position));
        const text = `${this.index + 1} / ${this.slides.length}`;
        if (this.counter && this.counter.textContent !== text) this.counter.textContent = text;
      }
      center(position, animate) {
        const slide = this.cards[position];
        const left = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left, behavior: animate && !reduced ? 'smooth' : 'instant' });
      }
      rebase() {
        const count = this.slides.length;
        if (count < 2 || (this.position >= count && this.position < count * 2)) return;
        const home = count + this.index;
        const shift = this.cards[home].offsetLeft - this.cards[this.position].offsetLeft;
        this.track.classList.add('is-repositioning');
        this.setCurrent(home);
        this.track.scrollTo({ left: this.track.scrollLeft + shift, behavior: 'instant' });
        void this.track.offsetWidth;
        this.track.classList.remove('is-repositioning');
      }
      go(index, animate = true) {
        clearTimeout(this.timer);
        const count = this.slides.length;
        const step = index - this.index;
        index = ((index % count) + count) % count;
        this.rebase();
        let target = count > 1 ? count + index : index;
        if (animate && count > 1 && Math.abs(step) === 1) {
          target = this.position + step;
        } else if (animate && count > 1) {
          [index, count + index, count * 2 + index].forEach((candidate) => {
            if (Math.abs(candidate - this.position) < Math.abs(target - this.position)) target = candidate;
          });
        }
        this.setCurrent(target);
        this.center(target, animate);
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.touching) this.timer = setTimeout(() => this.settle(), 160);
      }
      settle() {
        clearTimeout(this.timer);
        if (this.touching || !this.track.clientWidth) return;
        const center = this.track.scrollLeft + this.track.clientWidth / 2;
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((slide, i) => {
          const delta = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
          if (delta < distance) { distance = delta; nearest = i; }
        });
        this.setCurrent(nearest);
        this.rebase();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jcked-reviews')) {
    customElements.define('jcked-reviews', class extends HTMLElement {
      connectedCallback() { queueMicrotask(() => this.init()); }
      disconnectedCallback() { this.events?.abort(); }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.items = [...this.querySelectorAll('[data-item]')];
        this.more = this.querySelector('[data-more]');
        this.less = this.querySelector('[data-less]');
        this.empty = this.querySelector('[data-empty]');
        this.phone = window.matchMedia('(max-width: 749px)');
        this.step = Math.max(1, Number(this.dataset.step) || 4);
        this.filter = '';
        this.initial = this.firstCount();
        this.shown = this.initial;

        /* switching between phone and desktop width resets an untouched list to that layout's count */
        this.phone.addEventListener('change', () => {
          const wasInitial = this.shown === this.initial;
          this.initial = this.firstCount();
          if (wasInitial) this.shown = this.initial;
          if (this.feed && this.items.length < this.shown && this.feedHasMore()) this.loadFeed().then(() => this.render());
          else this.render();
        }, options);

        this.addEventListener('click', (event) => {
          const pill = event.target.closest('[data-filter]');
          if (pill) {
            this.filter = pill.dataset.filter;
            this.querySelectorAll('[data-filter]').forEach((p) => {
              const on = p === pill;
              p.classList.toggle('is-on', on);
              p.setAttribute('aria-pressed', String(on));
            });
            this.shown = this.initial;
            this.render();
            return;
          }
          if (event.target.closest('[data-more]')) {
            this.shown += this.step;
            if (this.feed && this.items.length < this.shown && this.feedHasMore()) this.loadFeed().then(() => this.render());
            else this.render();
            return;
          }
          if (event.target.closest('[data-less]')) {
            this.shown = this.initial;
            this.render();
            this.scrollTo(this, 'smooth');
            return;
          }
          if (event.target.closest('[data-cta]')) this.cta();
        }, options);
        if (this.items.length) this.render();
        this.initFeed();
      }
      firstCount() {
        const desktop = Math.max(1, Number(this.dataset.initialDesktop) || 4);
        const mobile = Math.max(1, Number(this.dataset.initialMobile) || 3);
        return this.phone.matches ? mobile : desktop;
      }
      /* Judge.me mode, in phases: pinned reviews (picked by ID in the editor, with their tag), then verified buyers rated 4+
         (highest rated first), then photo reviews (setting "Show photo reviews first"), then every other review, 30 at a
         time, so "Show more reviews" keeps going until every review is shown. Same cards; only verified ones get the badge
         (Judge.me's verified_buyer: reviews imported from another provider are not verified there).
         With "Imported review names" set, the phases after the photos read the whole list once (Judge.me serves 30 per
         page): every other real review, highest rated first, then the imported reviews, 30 at a time. */
      feedHasMore() { const f = this.feed; return !!f && (f.phase < f.phases.length - 1 || f.page < f.pages); }
      initFeed() {
        const list = this.querySelector('[data-jm-list]');
        const tpl = this.querySelector('template[data-jm-item]');
        if (!list || !tpl) { this.feed = null; return; }
        let pins = [];
        try { pins = JSON.parse(this.querySelector('[data-jm-pins]').textContent).filter((p) => p.id); } catch (e) { pins = []; }
        const phases = [];
        if (pins.length) phases.push('pins');
        phases.push('verified');
        if (list.dataset.photosFirst === 'true') phases.push('photos');
        const imported = (list.dataset.imported || '').trim().toLowerCase();
        if (imported) phases.push('named', 'imported'); else phases.push('all');
        this.feed = { list, tpl, shop: list.dataset.shop, productId: list.dataset.productId, pins, phases, phase: 0, page: 0, pages: 1, busy: null, seen: new Set(), photoPages: {}, imported, tail: [] };
        const start = () => this.loadFeed().then(() => this.render()); /* on page load, not on scroll, so reviews are ready before they come into view */
        if (window.jxJudgeme) start(); else document.addEventListener('jx:judgeme:ready', start, { once: true, signal: this.events.signal });
      }
      nextPhase() { const f = this.feed; f.phase += 1; f.page = 0; f.pages = 1; }
      isImported(r) { const p = this.feed.imported; return !!p && r.name.toLowerCase().startsWith(p); }
      async readAll() { /* every page of the list, highest rated first: named customers now, imported ones kept for later */
        const f = this.feed;
        const get = (n, dir) => window.jxJudgeme.fetchPage({ shop: f.shop, productId: f.productId, page: n, perPage: 30, verifiedOnly: false, dir });
        const first = await get(1);
        const results = [first];
        const rest = [];
        for (let n = 2; n <= first.pages; n++) rest.push(n);
        const worker = async () => { /* a few requests at a time; a page that fails is skipped */
          while (rest.length) { const n = rest.shift(); results[n - 1] = await get(n).catch(() => null); }
        };
        await Promise.all([1, 2, 3, 4, 5, 6].map(worker));
        const all = [];
        results.forEach((res) => res && all.push(...res.reviews));
        /* Judge.me stops after 33 pages, so a big product's lowest rated reviews are cut off: read from the lowest rated
           end past the lowest rating already read (same-rated reviews come in a different order each way) and add the
           missing ones, highest rated of them first */
        const ids = new Set(all.map((r) => r.id));
        const low = [];
        if (first.pages >= 33 && all.length) {
          const floor = Math.min(...all.map((r) => r.rating));
          for (let n = 1; n <= 33; n++) {
            const res = await get(n, 'asc').catch(() => null);
            if (!res) break;
            res.reviews.forEach((r) => { if (!ids.has(r.id)) { ids.add(r.id); low.push(r); } });
            if (res.reviews.some((r) => r.rating > floor) || n >= res.pages) break;
          }
        }
        all.push(...low.reverse());
        const tail = [], real = [];
        all.forEach((r) => (this.isImported(r) ? tail : real).push(r));
        /* real reviews by rating, verified buyers first among the same rating */
        real.sort((a, b) => b.rating - a.rating || b.verified - a.verified).forEach((r) => this.add(r));
        f.tail = tail;
      }
      add(r, tag) {
        const f = this.feed;
        const key = [r.name, r.date, r.body.join(' ')].join('|');
        if (f.seen.has(r.id) || f.seen.has(key)) return; /* same review, or a duplicate Judge.me holds twice */
        f.seen.add(r.id); f.seen.add(key);
        f.list.appendChild(this.card(r, tag));
      }
      photoPage(n) { /* photo-first pages are shared by the pinned and photo phases */
        const f = this.feed;
        if (!f.photoPages[n]) f.photoPages[n] = window.jxJudgeme.fetchPage({ shop: f.shop, productId: f.productId, page: n, perPage: 30, verifiedOnly: false, sort: 'pictures' });
        return f.photoPages[n];
      }
      async findPins() { /* look the pinned IDs up among photo reviews, then highest rated, a few pages each */
        const f = this.feed, found = {};
        const want = () => f.pins.filter((p) => !found[p.id]);
        const scan = async (get) => {
          for (let n = 1; n <= 8 && want().length; n++) {
            const res = await get(n);
            res.reviews.forEach((r) => { const id = (r.id || '').toLowerCase(); f.pins.forEach((p) => { if (!found[p.id] && id.startsWith(p.id)) found[p.id] = r; }); });
            if (n >= res.pages) break;
          }
        };
        await scan((n) => this.photoPage(n));
        if (want().length) await scan((n) => window.jxJudgeme.fetchPage({ shop: f.shop, productId: f.productId, page: n, perPage: 30, verifiedOnly: false }));
        f.pins.forEach((p) => { if (found[p.id]) this.add(found[p.id], p.tag); });
      }
      loadFeed() {
        const f = this.feed;
        if (!f) return Promise.resolve();
        if (f.busy) return f.busy;
        f.list.setAttribute('aria-busy', 'true');
        const phase = f.phases[f.phase];
        let step;
        if (phase === 'pins') {
          step = this.findPins().then(() => this.nextPhase());
        } else if (phase === 'named') {
          step = this.readAll().then(() => { this.nextPhase(); f.pages = Math.ceil(f.tail.length / 30); });
        } else if (phase === 'imported') {
          f.tail.slice(f.page * 30, (f.page + 1) * 30).forEach((r) => this.add(r));
          f.page += 1;
          step = Promise.resolve();
        } else {
          const n = f.page + 1;
          const req = phase === 'photos' ? this.photoPage(n) : window.jxJudgeme.fetchPage({ shop: f.shop, productId: f.productId, page: n, perPage: 30, verifiedOnly: phase === 'verified' });
          step = req.then((res) => {
            f.page = res.page;
            f.pages = res.pages;
            let done = f.page >= f.pages;
            res.reviews.forEach((r) => {
              if (phase === 'verified' && r.rating < 4) { done = true; return; } /* lower rated verified reviews take their place by rating later */
              if (phase === 'photos' && !r.photo) { done = true; return; } /* photo reviews are over */
              if (phase === 'photos' && this.isImported(r)) return; /* imported photo reviews wait for the end */
              this.add(r);
            });
            if (done && f.phase < f.phases.length - 1) this.nextPhase();
          });
        }
        f.busy = step
          .then(() => {
            this.items = [...this.querySelectorAll('[data-item]')];
            /* keep going until the first screen is full */
            if (this.items.length < this.shown && this.feedHasMore()) { f.busy = null; return this.loadFeed(); }
          })
          .catch(() => { f.phase = f.phases.length - 1; f.pages = f.page; }) /* Judge.me unreachable: show what we have */
          .finally(() => { f.busy = null; f.list.removeAttribute('aria-busy'); });
        return f.busy;
      }
      card(r, tag) {
        const li = this.feed.tpl.content.firstElementChild.cloneNode(true);
        const q = (sel) => li.querySelector(sel);
        const stars = q('[data-jm-stars]');
        stars.style.setProperty('--jrv-fill', (r.rating * 20) + '%');
        stars.setAttribute('aria-label', r.rating + ' out of 5 stars');
        const set = (sel, text) => { const el = q(sel); if (text) el.textContent = text; else el.remove(); };
        set('[data-jm-date]', r.date);
        set('[data-jm-name]', r.name);
        set('[data-jm-loc]', r.location);
        set('[data-jm-title]', r.title);
        window.jxJudgeme.fillBody(q('[data-jm-body]'), r.body);
        if (r.photo) { q('[data-jm-photo] img').src = r.photo; li.setAttribute('data-photo', ''); } else q('[data-jm-photo]').remove();
        if (!r.verified) q('.jrv__verified')?.remove();
        const tagEl = q('[data-jm-tag]');
        if (tag) { tagEl.textContent = tag; li.dataset.tag = tag; } else tagEl.remove();
        /* Theme editor only: the review's ID, to copy into a "Pinned review" block */
        if (window.Shopify && Shopify.designMode && r.id) { /* tap to copy; the theme editor preview otherwise grabs the click to select the section */
          const shortId = String(r.id).slice(0, 8);
          const idEl = document.createElement('button'); idEl.type = 'button'; idEl.className = 'jrv__id'; idEl.textContent = 'Review ID: ' + shortId + ' · Copy'; idEl.title = 'Copy this ID into a Pinned review block';
          idEl.addEventListener('click', (e) => {
            e.preventDefault(); e.stopPropagation();
            const done = () => { idEl.textContent = 'Copied ' + shortId; setTimeout(() => { idEl.textContent = 'Review ID: ' + shortId + ' · Copy'; }, 1500); };
            const fallback = () => { const ta = document.createElement('textarea'); ta.value = shortId; ta.style.cssText = 'position:fixed;opacity:0'; document.body.appendChild(ta); ta.select(); let ok = false; try { ok = document.execCommand('copy'); } catch (x) {} if (ok) done(); else idEl.textContent = 'Select & copy: ' + shortId; ta.remove(); };
            if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(shortId).then(done, fallback); else fallback();
          });
          li.prepend(idEl);
        }
        return li;
      }
      offset() { return Math.max(0, Number(this.dataset.offset) || 0); }
      scrollTo(target, behavior) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - this.offset());
        window.scrollTo({ top, behavior: reduced ? 'instant' : behavior });
      }
      visible(el) { return el && el.getClientRects().length > 0; }
      cta() {
        const mode = this.dataset.ctaMode || 'form';
        if (mode === 'top') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
        let target = null;
        if (mode === 'custom') {
          const raw = (this.dataset.ctaId || '').trim();
          const id = raw.replace(/^#/, '');
          target = document.getElementById(id) || document.getElementById('shopify-section-' + id);
          if (!target && raw) { try { target = document.querySelector(raw); } catch (_) { target = null; } }
          if (!target && id) { try { target = document.querySelector('.' + id); } catch (_) { target = null; } }
        }
        if (!this.visible(target)) {
          const forms = [...document.querySelectorAll('form[action*="/cart/add"]')].filter((form) => this.visible(form) && !form.closest('cart-drawer, .cart-drawer, dialog, [role="dialog"], quick-add-modal, .quick-add, .card, .product-card'));
          target = forms.length ? (forms[0].closest('.shopify-section, [id^="shopify-section-"]') || forms[0]) : document.querySelector('h1');
        }
        if (this.visible(target)) this.scrollTo(target, 'smooth');
      }
      matches(item) {
        if (!this.filter) return true;
        if (this.filter === '__photos') return item.hasAttribute('data-photo');
        return (item.dataset.tag || '').toLowerCase() === this.filter.toLowerCase();
      }
      render() {
        let visible = 0;
        this.items.forEach((item) => {
          const ok = this.matches(item);
          const show = ok && visible < this.shown;
          if (ok) visible++;
          item.hidden = !show;
        });
        const total = this.items.filter((item) => this.matches(item)).length;
        const moreRemote = this.feedHasMore();
        if (this.more) this.more.hidden = total <= this.shown && !moreRemote;
        if (this.less) this.less.hidden = this.shown <= this.initial;
        if (this.empty) this.empty.hidden = total > 0;
        /* Judge.me mode: a product with nothing to show (e.g. only 1-star reviews, which are never shown) hides the section */
        if (this.feed && !this.feed.busy && !moreRemote && !this.items.length) (this.closest('.shopify-section') || this).hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-breakdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jcked-ingredient-explorer')) {
    customElements.define('jcked-ingredient-explorer', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.init());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        clearTimeout(this.scrollTimer);
      }

      init() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        clearTimeout(this.scrollTimer);
        this.events = new AbortController();
        this.touching = false;
        const options = { signal: this.events.signal };

        this.buttons = [...this.querySelectorAll('[data-choice]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.track = this.querySelector('[data-mobile-track]');
        this.track?.querySelectorAll('[data-loop-clone]').forEach((node) => node.remove());
        this.slides = [...this.querySelectorAll('[data-mobile-slide]')];
        this.counter = this.querySelector('[data-mobile-count]');
        this.status = this.querySelector('[data-status]');
        this.buildLoop();

        if (!this.panels.length) return;
        this.setAttribute('data-ready', '');
        this.querySelector('[data-picker]').hidden = this.panels.length < 2;
        this.querySelector('[data-mobile-carousel]').hidden = false;

        this.addEventListener('click', (event) => {
          const slide = event.target.closest('[data-mobile-slide]');
          if (slide && this.track?.contains(slide)) { this.select(Number(slide.dataset.mobileSlide), true); return; }
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-mobile-step')) this.select(this.index + Number(button.dataset.mobileStep), true);
          if (button.hasAttribute('data-choice')) this.select(Number(button.dataset.choice), true);
        }, options);

        this.select(Math.min(this.index || 0, this.panels.length - 1));

        this.track.addEventListener('scroll', () => this.scheduleSync(), { ...options, passive: true });
        this.track.addEventListener('scrollend', () => { clearTimeout(this.scrollTimer); this.syncFromScroll(); }, options);
        this.track.addEventListener('touchstart', () => { this.touching = true; clearTimeout(this.scrollTimer); }, { ...options, passive: true });
        for (const type of ['touchend', 'touchcancel']) {
          this.track.addEventListener(type, (event) => { this.touching = event.touches.length > 0; this.scheduleSync(); }, { ...options, passive: true });
        }

        this.track.addEventListener('keydown', (event) => {
          if (!event.target.closest('[data-mobile-slide]')) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0
            : event.key === 'End' ? this.panels.length - 1
            : this.index + (event.key === 'ArrowRight' ? 1 : -1);
          this.select(next, true);
          this.slides[this.index].focus({ preventScroll: true });
        }, options);

        if (typeof ResizeObserver === 'function') {
          this.resizeObserver = new ResizeObserver(() => this.centerMobile());
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.centerMobile(), options);
        }

        document.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex((panel) => panel.dataset.blockId === event.detail?.blockId);
          if (index !== -1) this.select(index, true);
        }, options);
      }

      buildLoop() {
        this.loopSlides = [...this.slides];
        if (!this.track || this.slides.length < 2) return;
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        for (const fragment of [before, after]) {
          this.slides.forEach((slide) => {
            const clone = document.createElement('div');
            clone.className = slide.className;
            clone.dataset.mobileSlide = slide.dataset.mobileSlide;
            clone.dataset.loopClone = 'true';
            clone.setAttribute('aria-hidden', 'true');
            slide.childNodes.forEach((child) => clone.append(child.cloneNode(true)));
            clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
            fragment.append(clone);
          });
        }
        this.track.prepend(before);
        this.track.append(after);
        this.loopSlides = [...this.track.querySelectorAll('[data-mobile-slide]')];
      }

      select(index, announce = false, center = true) {
        const count = this.panels.length;
        if (!Number.isInteger(index) || !count) return;
        index = ((index % count) + count) % count;
        this.index = index;
        const focusInCarousel = this.track?.contains(document.activeElement);

        this.panels.forEach((panel, i) => {
          if (i !== index && panel.contains(document.activeElement)) {
            const target = this.track?.clientWidth ? this.slides[index] : this.buttons[index];
            target.focus({ preventScroll: true });
          }
          panel.hidden = i !== index;
          this.buttons[i].setAttribute('aria-pressed', String(i === index));
        });

        this.loopSlides.forEach((slide) => slide.setAttribute('aria-pressed', String(Number(slide.dataset.mobileSlide) === index)));
        this.slides.forEach((slide, i) => { slide.tabIndex = i === index ? 0 : -1; });
        if (focusInCarousel && document.activeElement !== this.slides[index]) this.slides[index].focus({ preventScroll: true });

        if (this.counter) this.counter.textContent = `${index + 1} / ${count}`;
        if (center) this.centerMobile();
        if (announce && this.status) this.status.textContent = `${this.panels[index].dataset.name} selected. Ingredient ${index + 1} of ${count}.`;
      }

      centerMobile() {
        if (!this.track?.clientWidth || !this.slides[this.index]) return;
        clearTimeout(this.scrollTimer);
        const track = this.track.getBoundingClientRect();
        const slide = this.slides[this.index].getBoundingClientRect();
        const left = this.track.scrollLeft + slide.left + slide.width / 2 - track.left - track.width / 2;
        this.track.scrollTo({ left, behavior: 'instant' });
      }

      scheduleSync() {
        clearTimeout(this.scrollTimer);
        if (!this.touching) this.scrollTimer = setTimeout(() => this.syncFromScroll(), 140);
      }

      syncFromScroll() {
        if (this.touching || !this.track?.clientWidth) return;
        const track = this.track.getBoundingClientRect();
        const center = track.left + track.width / 2;
        let nearest = null;
        let distance = Infinity;
        this.loopSlides.forEach((slide) => {
          const rect = slide.getBoundingClientRect();
          const delta = Math.abs(rect.left + rect.width / 2 - center);
          if (delta < distance) { nearest = slide; distance = delta; }
        });
        if (!nearest) return;
        const index = Number(nearest.dataset.mobileSlide);
        if (index !== this.index) this.select(index, true, false);
        if (nearest.hasAttribute('data-loop-clone')) this.centerMobile();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jcked-review-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jcked-review-ticker')) {
    customElements.define('jcked-review-ticker', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.jcked-review-ticker__track');
        this.run = this.track?.querySelector('.jcked-review-ticker__run');
        this.sequence = this.run?.querySelector('.jcked-review-ticker__sequence');
        if (!this.sequence) return;

        this.update = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.fillTrack());
        };
        this.pauseEditor = () => this.setAttribute('data-editor-paused', '');
        this.resumeEditor = () => this.removeAttribute('data-editor-paused');
        this.addEventListener('shopify:block:select', this.pauseEditor);
        this.addEventListener('shopify:block:deselect', this.resumeEditor);
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this);
        this.observer.observe(this.sequence);
        this.update();
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.update();
        });
      }

      fillTrack() {
        const sequenceWidth = this.sequence.getBoundingClientRect().width;
        const viewportWidth = this.getBoundingClientRect().width;
        if (!sequenceWidth || !viewportWidth) return;

        const repetitions = Math.max(1, Math.ceil(viewportWidth / sequenceWidth));
        if (repetitions === this.repetitions) return;
        this.repetitions = repetitions;

        while (this.run.children.length > 1) this.run.lastElementChild.remove();
        while (this.track.children.length > 1) this.track.lastElementChild.remove();

        const cloneHidden = (source) => {
          const copy = source.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('[data-shopify-editor-block]').forEach((block) => {
            block.removeAttribute('data-shopify-editor-block');
          });
          return copy;
        };

        for (let i = 1; i < repetitions; i += 1) {
          this.run.appendChild(cloneHidden(this.sequence));
        }
        this.track.appendChild(cloneHidden(this.run));
        this.style.setProperty('--tk-duration', `${Number(this.dataset.speed) * repetitions}s`);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.removeEventListener('shopify:block:select', this.pauseEditor);
        this.removeEventListener('shopify:block:deselect', this.resumeEditor);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shred-challenge"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jcked-shred-challenge')) {
    customElements.define('jcked-shred-challenge', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.init());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.raf);
        this.events?.abort();
        this.observer?.disconnect();
      }
      init() {
        this.events?.abort();
        this.observer?.disconnect();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.track = this.querySelector('[data-track]');
        this.cards = [...this.querySelectorAll('[data-card]')];
        if (!this.track || !this.cards.length) return;
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.prev = this.querySelector('[data-step="-1"]');
        this.next = this.querySelector('[data-step="1"]');
        this.status = this.querySelector('[data-status]');
        this.index = 0;
        this.setAttribute('data-ready', '');
        const controls = this.querySelector('[data-controls]');
        if (controls) controls.hidden = this.cards.length < 2;

        this.addEventListener('click', (event) => {
          const dot = event.target.closest('[data-dot]');
          if (dot) { this.go(Number(dot.dataset.dot)); return; }
          const step = event.target.closest('[data-step]');
          if (step) this.go(this.index + Number(step.dataset.step));
        }, options);
        this.track.addEventListener('keydown', (event) => {
          const map = { ArrowRight: this.index + 1, ArrowLeft: this.index - 1, Home: 0, End: this.cards.length - 1 };
          if (!(event.key in map)) return;
          event.preventDefault();
          this.go(map[event.key]);
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.sync());
        }, { ...options, passive: true });
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.go(index, false);
        }, options);
        this.observer = new ResizeObserver(() => this.sync());
        this.observer.observe(this.track);
        this.sync();
      }
      padLeft() {
        return parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      }
      cardLeft(index) {
        return this.cards[index].offsetLeft - this.padLeft();
      }
      lastIndex() {
        const maxLeft = this.track.scrollWidth - this.track.clientWidth;
        for (let i = 0; i < this.cards.length; i++) {
          if (this.cardLeft(i) >= maxLeft - 1) return i;
        }
        return this.cards.length - 1;
      }
      go(index, animate = true) {
        const last = this.lastIndex();
        index = Math.max(0, Math.min(last, index));
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.cardLeft(index), behavior: animate && !reduced ? 'smooth' : 'instant' });
        this.paint(index);
      }
      sync() {
        const left = this.track.scrollLeft;
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, i) => {
          const delta = Math.abs(this.cardLeft(i) - left);
          if (delta < distance) { distance = delta; nearest = i; }
        });
        this.paint(Math.min(nearest, this.lastIndex()));
      }
      paint(index) {
        this.index = index;
        const last = this.lastIndex();
        this.dots.forEach((dot, i) => {
          dot.hidden = i > last;
          dot.classList.toggle('is-on', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        if (this.prev) this.prev.disabled = index <= 0;
        if (this.next) this.next.disabled = index >= last;
        if (this.status) {
          const text = `Card ${index + 1} of ${this.cards.length}`;
          if (this.status.textContent !== text) this.status.textContent = text;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jcked-tabbed-content')) {
    customElements.define('jcked-tabbed-content', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.setup());
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      setup() {
        if (!this.isConnected || this.controller) return;
        this.tabs = Array.from(this.querySelectorAll('[data-jt-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-jt-panel]'));
        if (!this.tabs.length || !this.panels.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelector('[data-jt-tablist]').setAttribute('role', 'tablist');
        this.tabs.forEach((tab) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.hash.slice(1));
        });
        this.panels.forEach((panel) => {
          panel.setAttribute('role', 'tabpanel');
          panel.tabIndex = 0;
        });
        this.setAttribute('data-enhanced', '');
        this.activate(this.dataset.defaultTab);
        this.addEventListener('click', (event) => this.onClick(event), options);
        this.addEventListener('keydown', (event) => this.onKeydown(event), options);
        document.addEventListener('shopify:block:select', (event) => {
          const block = Array.from(this.querySelectorAll('[data-jt-block]')).find((item) => item.dataset.jtBlock === event.detail?.blockId);
          if (!block) return;
          this.activate(block.closest('[data-jt-panel]').dataset.jtPanel);
          requestAnimationFrame(() => { if (block.isConnected) block.scrollIntoView({ block: 'nearest', behavior: 'instant' }); });
        }, options);
        window.addEventListener('hashchange', () => this.openHash(), options);
        this.openHash();
      }

      activate(key, focus = false) {
        const selected = this.tabs.find((tab) => tab.dataset.jtTab === key) || this.tabs[0];
        key = selected.dataset.jtTab;
        this.tabs.forEach((tab) => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.jtPanel !== key; });
        const cta = this.querySelector('[data-jt-cta]');
        if (cta) cta.hidden = cta.dataset.jtCta === 'none' || (cta.dataset.jtCta !== 'all' && key !== 'expect');
        if (focus) selected.focus({ preventScroll: true });
      }

      onKeydown(event) {
        const tab = event.target.closest('[data-jt-tab]');
        if (!tab || !this.tabs.includes(tab)) return;
        let index = this.tabs.indexOf(tab);
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        if (event.key === 'ArrowRight') index += direction;
        else if (event.key === 'ArrowLeft') index -= direction;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.tabs.length - 1;
        else if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          this.activate(tab.dataset.jtTab);
          return;
        } else return;
        event.preventDefault();
        this.activate(this.tabs[(index + this.tabs.length) % this.tabs.length].dataset.jtTab, true);
      }

      onClick(event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const tab = event.target.closest('[data-jt-tab]');
        if (tab && this.tabs.includes(tab)) {
          event.preventDefault();
          this.activate(tab.dataset.jtTab);
          tab.blur();
          return;
        }
        const link = event.target.closest('a[data-jt-link]');
        if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
        const target = this.hashTarget(url.hash);
        if (!target) return;
        const panel = target.closest('[data-jt-panel]');
        if (panel && this.contains(panel)) this.activate(panel.dataset.jtPanel);
        if (!target.getClientRects().length) return;
        event.preventDefault();
        this.scrollToTarget(target, true);
        try { history.pushState(null, '', url.hash); } catch (_) {}
      }

      hashTarget(hash) {
        try { return hash.length > 1 ? document.getElementById(decodeURIComponent(hash.slice(1))) : null; }
        catch (_) { return null; }
      }

      openHash() {
        const target = this.hashTarget(location.hash);
        if (!target || (target !== this && !this.contains(target))) return;
        const panel = target.closest('[data-jt-panel]');
        if (panel) this.activate(panel.dataset.jtPanel);
        requestAnimationFrame(() => { if (target.isConnected) this.scrollToTarget(target, false); });
      }

      scrollToTarget(target, animate) {
        const offset = Number(this.dataset.scrollOffset) || 0;
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top, behavior: animate && !reduceMotion ? 'smooth' : 'instant' });
        const hadTabindex = target.hasAttribute('tabindex');
        if (!hadTabindex) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (!hadTabindex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jcked-video-testimonials')) {
    customElements.define('jcked-video-testimonials', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.init());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.raf);
        this.events?.abort();
        this.observer?.disconnect();
        this.pauseAll();
      }
      init() {
        this.events?.abort();
        this.observer?.disconnect();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.track = this.querySelector('[data-track]');
        this.cards = [...this.querySelectorAll('[data-card]')];
        if (!this.track || !this.cards.length) return;
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.prev = this.querySelector('[data-step="-1"]');
        this.next = this.querySelector('[data-step="1"]');
        this.status = this.querySelector('[data-status]');
        this.index = 0;
        const controls = this.querySelector('[data-controls]');
        if (controls) controls.hidden = this.cards.length < 2;

        this.addEventListener('click', (event) => {
          const play = event.target.closest('[data-play]');
          if (play) { this.toggle(play.closest('[data-card]')); return; }
          const expand = event.target.closest('[data-expand]');
          if (expand) { this.expand(expand.closest('[data-card]')); return; }
          const video = event.target.closest('[data-video]');
          if (video) { this.toggle(video.closest('[data-card]')); return; }
          const dot = event.target.closest('[data-dot]');
          if (dot) { this.go(Number(dot.dataset.dot)); return; }
          const step = event.target.closest('[data-step]');
          if (step) this.go(this.index + Number(step.dataset.step));
        }, options);

        this.querySelectorAll('[data-video]').forEach((video) => {
          const card = video.closest('[data-card]');
          video.addEventListener('play', () => { this.pauseAll(video); card.classList.add('is-playing'); card.classList.remove('is-loading'); }, options);
          video.addEventListener('pause', () => card.classList.remove('is-playing'), options);
          video.addEventListener('ended', () => { card.classList.remove('is-playing'); video.currentTime = 0; }, options);
          video.addEventListener('waiting', () => card.classList.add('is-loading'), options);
          video.addEventListener('playing', () => card.classList.remove('is-loading'), options);
        });

        this.track.addEventListener('keydown', (event) => {
          const map = { ArrowRight: this.index + 1, ArrowLeft: this.index - 1, Home: 0, End: this.cards.length - 1 };
          if (!(event.key in map)) return;
          event.preventDefault();
          this.go(map[event.key]);
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.sync());
        }, { ...options, passive: true });
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.go(index, false);
        }, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseAll(); }, options);
        this.observer = new ResizeObserver(() => this.sync());
        this.observer.observe(this.track);
        this.sync();
      }

      /* ---------- video ---------- */
      pauseAll(except) {
        this.querySelectorAll('[data-video]').forEach((video) => { if (video !== except && !video.paused) video.pause(); });
      }
      toggle(card) {
        const video = card && card.querySelector('[data-video]');
        if (!video) return;
        if (video.paused) {
          card.classList.add('is-loading');
          video.muted = false;
          const attempt = video.play();
          if (attempt && attempt.catch) attempt.catch(() => { video.muted = true; video.play().catch(() => card.classList.remove('is-loading')); });
        } else {
          video.pause();
        }
      }
      expand(card) {
        const video = card && card.querySelector('[data-video]');
        if (!video) return;
        video.muted = false;
        if (video.paused) video.play().catch(() => {});
        if (video.requestFullscreen) video.requestFullscreen().catch(() => {});
        else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
        else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
      }

      /* ---------- carousel ---------- */
      padLeft() { return parseFloat(getComputedStyle(this.track).paddingLeft) || 0; }
      cardLeft(index) { return this.cards[index].offsetLeft - this.padLeft(); }
      lastIndex() {
        const maxLeft = this.track.scrollWidth - this.track.clientWidth;
        for (let i = 0; i < this.cards.length; i++) { if (this.cardLeft(i) >= maxLeft - 1) return i; }
        return this.cards.length - 1;
      }
      go(index, animate = true) {
        const last = this.lastIndex();
        index = Math.max(0, Math.min(last, index));
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.cardLeft(index), behavior: animate && !reduced ? 'smooth' : 'instant' });
        this.paint(index);
      }
      sync() {
        const left = this.track.scrollLeft;
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, i) => {
          const delta = Math.abs(this.cardLeft(i) - left);
          if (delta < distance) { distance = delta; nearest = i; }
        });
        this.paint(Math.min(nearest, this.lastIndex()));
      }
      paint(index) {
        this.index = index;
        const last = this.lastIndex();
        this.dots.forEach((dot, i) => {
          dot.hidden = i > last;
          dot.classList.toggle('is-on', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        if (this.prev) this.prev.disabled = index <= 0;
        if (this.next) this.next.disabled = index >= last;
        if (this.status) {
          const text = `Video ${index + 1} of ${this.cards.length}`;
          if (this.status.textContent !== text) this.status.textContent = text;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
